'use strict';
var REGEXP = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/;

class UrlDirective {
    restrict = 'A';
    require = 'ngModel';

    link(scope, element, attrs, ngModelCtrl) {
        ngModelCtrl.$parsers.push((viewValue) => {
            if (!viewValue || REGEXP.test(viewValue)) {
                ngModelCtrl.$setValidity('url', true);
                return viewValue;
            }
            ngModelCtrl.$setValidity('url', false);
            return undefined;
        });
    }
}

export let url:any = () => new UrlDirective();


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/validation/url.directive.ts